// @ts-nocheck
if (!customElements.get('notify-me-drawer-content')) {
    customElements.define(
      'notify-me-drawer-content',
      class NotifyMeDrawerContent extends HTMLElement {
        constructor() {
          super();

          this.openButtons = document.querySelectorAll('[out-of-stock-drawer-trigger]');
          this.submitButton = this.querySelector('#notify-me-submit-button');
          this.form = this.querySelector('#notify-me-form');
          this.nameInput = this.querySelector('#notify-me-name');
          this.emailInput = this.querySelector('#notify-me-email');
          this.timeoutId;

            this.openButtons.forEach(button => {
                button.addEventListener('click', () => {
                    this.openButtonHandler();
                })
            })            
        }

        openButtonHandler(){
          setTimeout(() => {
            const stoqBtn = document.querySelector('.restock-rocket-button-cover');
            if(stoqBtn){
                stoqBtn.click();
            }

            this.submitButton.querySelector('span').textContent = this.submitButton.getAttribute('data-normal-text');
            this.submitButton.classList.remove('continue');
            document.querySelector('.notify-me-success').classList.add('display-none');
          }, 100);
        }

        nameInputChange(e){
          const stoqNameInput = document.querySelector('#restock-rocket #form-Name');
          if(!stoqNameInput) return;

          stoqNameInput.value = e.target.value;
          stoqNameInput.dispatchEvent(new Event('input', { bubbles: true }));
          stoqNameInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        emailInputChange(e){
          const stoqEmailInput = document.querySelector('#restock-rocket #form-Email');
          if(!stoqEmailInput) return;

          stoqEmailInput.value = e.target.value;
          stoqEmailInput.dispatchEvent(new Event('input', { bubbles: true }));
          stoqEmailInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        formSubmission(e){
          e.preventDefault();

          const stoqButton = document.querySelector('#restock-rocket #form-Button');             

          document.querySelector('.notify-me-error').classList.add('display-none');
          document.querySelector('.notify-me-success').classList.add('display-none');

          if(stoqButton){
            stoqButton.click();  
            this.submitButton.disabled = true;  
            this.timeoutId = setTimeout(() => {
              document.querySelector('.notify-me-error').classList.remove('display-none');
              document.querySelector('.notify-me-error').textContent = "Request timeout. Please try again.";
            }, 7000);     

          }else{
             document.querySelector('.notify-me-error').classList.remove('display-none');
             document.querySelector('.notify-me-error').textContent = "Stoq form not found.";
          }
        }

        connectedCallback() {         
          this.form.addEventListener('submit', (e) => {
            this.formSubmission(e);
          })

          this.nameInput.addEventListener('input', (e) => {
            this.nameInputChange(e);
          });

          this.emailInput.addEventListener('input', (e) => {
            this.emailInputChange(e);
          });

          //Observer for form error
          const observerError = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
              for (const node of mutation.addedNodes) {
                if (node.nodeType === 1 && node.id === 'form-Error-Message') {
                  document.querySelector('.notify-me-error').classList.remove('display-none');
                  document.querySelector('.notify-me-error').textContent = node.textContent;
                  clearTimeout(this.timeoutId);
                  this.submitButton.disabled = false;  
                  return;
                }
              }
            }
          });

          observerError.observe(document.body, {
            childList: true,
            subtree: true,
          });

          // Observer for form success
          const observerSuccess = new MutationObserver(() => {
            const successNode = document.getElementById('form-Success-Content');

            if (!successNode) return;

            const notifyEl = document.querySelector('.notify-me-success');
            if (notifyEl) {
              notifyEl.classList.remove('display-none');
            }

            this.nameInput.value = '';
            this.emailInput.value = '';
            clearTimeout(this.timeoutId);

            this.submitButton.disabled = false;
            setTimeout(() => {
              this.submitButton.querySelector('span').textContent = this.submitButton.getAttribute('data-success-text');
              this.submitButton.classList.add('continue');
            }, 100);
          });

          observerSuccess.observe(document.body, {
            childList: true,
            subtree: true,
          });
        }    
      }
    );
  }